import axios from 'axios';

export default function updateControlStatus({ controls }) {
    return new Promise((resolve, reject) => axios
        .post('/account/system-admin/api/v1/update-master-controls',
          { controls })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message)));
}
